import { PdlScoreDetail } from '@/features';
import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/pdl/$scoreId')({
  // The API takes a numeric id; anything else can't be a score.
  params: {
    parse: ({ scoreId }) => {
      const id = Number(scoreId);
      if (!Number.isInteger(id)) throw notFound();
      return { scoreId: id };
    },
    stringify: ({ scoreId }) => ({ scoreId: String(scoreId) }),
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <PdlScoreDetail />;
}
